module.exports = __webpack_public_path__ + "img/front-side.27249a83.svg";